import * as React from 'react';

const StarListerBadge32 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    d: "M32 16c0 8.836-7.163 16-16 16S0 24.836 0 16 7.164 0 16 0s16 7.163 16 16"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "m13.621 18.945-3.424-1.14-1.141-3.428c-.267-.8-1.4-.8-1.667 0l-1.141 3.428-3.426 1.14c-.8.267-.8 1.399 0 1.666l3.426 1.14 1.141 3.427c.267.8 1.4.8 1.667 0l1.141-3.427 3.424-1.14c.801-.267.801-1.4 0-1.666"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M11.337 22.637h12.042a1.294 1.294 0 0 0 .578-2.45l-7.864-3.931-2.53 1.264-2.031-.676 3.807-1.903v-1.444a1.525 1.525 0 0 1 1.229-1.494 2.274 2.274 0 0 0 1.76-2.636 2.27 2.27 0 0 0-4.502.417h-1.514c0-1.123.493-2.18 1.352-2.9a3.8 3.8 0 0 1 3.114-.824c1.523.269 2.773 1.521 3.04 3.045.355 2.033-.935 3.957-2.937 4.38l-.026 1.459 7.779 3.89a2.808 2.808 0 0 1-1.256 5.317h-12.56zM27.7 10.583l-1.713-.57-.57-1.713a.44.44 0 0 0-.834 0l-.57 1.713-1.713.57c-.4.134-.4.7 0 .834l1.713.57.57 1.713c.134.4.7.4.834 0l.57-1.713 1.713-.57c.4-.134.4-.7 0-.834"
  }
));
StarListerBadge32.Size = 32;
StarListerBadge32.Title = "StarListerBadge";

export { StarListerBadge32 as default };
